import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { updateGlobalState } from "src/features/globalSlice";
import AuthSideBarButtons from "./authsidebarbuttons/AuthSideBarButtons";
import s from "./MobileNav.module.scss";
import MobileNavCloseBtn from "./mobilenav-closebutton/MobileNavCloseBtn";
import NavLinksSideBar from "./navlink-sidebar/NavLinksSideBar";
import UserProfileSidebar from "./userprofile-sidebar/UserProfileSidebar";

const MobileNav = () => {
  const { isMobileMenuActive } = useSelector((state) => state.global);
  const activeClass = isMobileMenuActive ? s.active : "";
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isMobileMenuActive) return;

    dispatch(updateGlobalState({ key: "isOverlayActive", value: false }));
    dispatch(updateGlobalState({ key: "isMobileMenuActive", value: false }));
  }, [location]);

  return (
    <aside className={`${s.mobileMenu} ${activeClass}`}>
      <MobileNavCloseBtn />
      <UserProfileSidebar />
      <NavLinksSideBar />
      <hr className={s.line}></hr>
      <AuthSideBarButtons />
    </aside>
  );
};

export default MobileNav;
